import { SVGProps } from 'react'

export const FreshIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 203 203"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M173.017 44.8885C197.565 104.809 173.017 137.025 152.25 154.788C157.325 172.55 137.096 176.214 129.413 167.475C106.793 175.275 60.8392 175.022 27.9126 142.1C10.1501 124.338 24.0048 84.8237 71.0501 58.3626C111.65 35.5251 152.25 22.8376 173.017 44.8885Z"
      fill="#FFDB1E"
    />
    <path
      d="M71.0494 58.3623C105.803 35.54 147.301 25.9838 164.267 40.7521C190.312 63.4373 109.112 114.756 78.6619 126.875C45.6744 140.004 63.437 170.012 45.6745 170.012C30.4495 170.012 32.987 149.712 19.3707 130.681C11.3269 119.44 31.2614 84.4884 71.0494 58.3623Z"
      fill="white"
      stroke="#FFDB1E"
    />
    <path
      d="M144.814 44.5178C168.388 50.8616 142.962 73.42 122.977 87.8381C104.037 101.5 89.4511 109.204 82.7673 112.35C80.9099 113.228 74.561 100.921 74.561 107.275C74.561 109.392 71.0085 118.633 69.821 119.08C62.8936 121.678 48.3893 125.626 40.2084 125.626C22.4915 125.626 30.4491 101.5 55.5044 79.3323C60.0313 75.3282 63.0053 76.059 67.0906 76.059C64.3654 72.136 64.3806 71.4052 69.1359 68.213C90.2834 53.9979 116.724 44.5077 127.95 42.7314C129.807 42.8025 132.112 44.5077 132.112 45.9236C134.192 45.2131 142.744 43.9545 144.814 44.5128V44.5178Z"
      fill="#FFE600"
    />
    <path
      d="M72.5566 83.6866C77.5555 79.8956 80.8999 78.5608 83.2091 70.8671C86.0815 71.4812 87.4771 70.4611 89.7558 67.3096C91.4001 69.6745 98.1651 70.3952 102.205 70.8671C98.5762 73.156 96.8405 75.191 94.8359 81.5551C87.4061 78.4543 78.7634 80.0224 72.5566 83.6866V83.6866Z"
      fill="white"
    />
  </svg>
)
